import "react-intl-tel-input/dist/main.css";

import queryString from "query-string";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import IntlTelInput from "react-intl-tel-input";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { MdError, MdCheckCircle } from "react-icons/md";
import { useCallback, useEffect, useState } from "react";

import {
  postChangePlan,
  getInfoPartners,
  getUserInformation,
  subscriptionsStripe,
  postUpgradeDdowngrade,
  subscriptionsStripeGetPlans,
} from "../../store/middleware";

import { COUNTRIES } from "../../constants/countries";
import Inputs from "../../components/Checkout/Inputs";
import Select from "../../components/Checkout/Select";
import NavBar from "../../components/Checkout/NavBar";
import { passwordValidator } from "../../utils/utils";
import { encryptValue } from "../../utils/fieldEncrypt";
import CardInfo from "../../components/Checkout/CardInfo";
import LineCard from "../../components/LineCard/LineCard";
import NewCardIMG from "../../assets/images/novo_cartao.png";
import ModalAlert from "../../components/Checkout/ModalAlert";
import SameCardIMG from "../../assets/images/mesmo_cartao.png";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import poweredStipePNG from "../../assets/images/powered_stipe.png";
import { setTypeSchedule } from "../../store/slices/generics.slice";
import ActivationImmdiateIMG from "../../assets/images/ativacao_imediata.png";
import ActivationScheduledIMG from "../../assets/images/ativacao_programada.png";
import CheckoutStripeComponent from "../../components/StripeCheckoutComponent/Checkout";

import {
  Container,
  Content,
  FormContainer,
  WrapperTitle,
  Title,
  Circle,
  Line,
  FormContent,
  WrapperInvalidPassword,
  ButtonNext,
  CardReviewSubscription,
  DivLeft,
  Discount,
  DivRight,
  TextPrivacyTerms,
  WrapperBuy,
  Buttonback,
  WrapperButtonBack,
  BtImageCheckout,
  FormContainerAuth,
} from "./styles";

function CheckoutSite() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { studentPlan } = useSelector((state) => state.studentReducer);
  const { isAuthenticated, language, user } = useSelector((state) => state.userReducer);

  const keyRecaptcha = process.env.REACT_APP_KEY_RECAPTCHA;

  const [plans, setPlans] = useState({});
  const [cardPay, setCardPay] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [changeType, setChangeType] = useState("");
  const [currencyURL, setCurrencyURL] = useState("");
  const [affiliateId, setAffiliateId] = useState("");
  const [customerId, setCustomerId] = useState(null);
  const [partnersInfo, setPartnersInfo] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [selectedPlanId, setSelectedPlanId] = useState(0);
  const [privacyTerms, setPrivacyTerms] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [changeTypeSchedule, setChangeTypeSchedule] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");
  const [password, setPassword] = useState("");
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const [showPayment, setShowPayment] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showCreateAccount, setShowCreateAccount] = useState(true);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  const [modalAlert, setModalAlert] = useState({ show: false, title: "", description: "", titleButton: "" });
  const [invalidPass, setInvalidPassword] = useState([
    { id: 1, message: "INVALID_PASS1", status: null },
    { id: 2, message: "INVALID_PASS2", status: null },
    { id: 3, message: "INVALID_PASS3", status: null },
    { id: 4, message: "INVALID_PASS4", status: null },
    { id: 5, message: "INVALID_PASS5", status: null },
  ]);

  const loadInfos = async () => {
    let cpnURL = queryString.parse(window?.location?.search)?.cpn;
    let planIdURL = queryString.parse(window?.location?.search)?.plan;
    let priceIdURL = queryString.parse(window?.location?.search)?.price;
    let partnerURL = queryString.parse(window?.location?.search)?.partner;
    let currencyURL = queryString.parse(window?.location?.search)?.currency;
    let affiliateURL = queryString.parse(window?.location?.search)?.affiliate;
    let changeTypeURL = queryString.parse(window?.location?.search)?.changeType;
    let studentPlanId = queryString.parse(window?.location?.search)?.studentPlanId;
    let languageURL = queryString.parse(window?.location.search)?.lang?.toLowerCase();
    let internalCheckoutURL = queryString.parse(window?.location.search)?.internalCheckout;

    if (languageURL === "en" || languageURL === "pt" || languageURL === "es" || languageURL === "fr") {
      i18n.changeLanguage(languageURL);
    } else {
      i18n.changeLanguage(language);
    }

    let responseIPAPI = await dispatch(getUserInformation());

    if (isAuthenticated) {
      setUserInfo(responseIPAPI);
      setShowCreateAccount(false);
      setCurrencyURL(currencyURL);
      setChangeType(changeTypeURL);
      setSelectedPlanId(studentPlanId);

      if (changeTypeURL === "downgrade") {
        setChangeTypeSchedule("nextCycle");
        setCardPay("current");
        setPrivacyTerms(true);
        setShowPayment(true);
      }

      if (changeTypeURL === "upgrade") {
        setCardPay("current");
        setPrivacyTerms(true);
        setChangeTypeSchedule("");
      }
      if (changeTypeURL === "checkout") {
        setCardPay("new");
        setPrivacyTerms(true);

        setCurrencyURL(currencyURL);
        setUserInfo(responseIPAPI);

        const body = {
          existingUser: true,
          student: {
            currency: currencyURL,
            timezone: user?.timezone,
            countryId: Number(user.countryId),
            name: decryptIfEncrypted(user.name).trim(),
            email: decryptIfEncrypted(user.email).trim(),
          },
          planId: planIdURL,
          priceId: priceIdURL,
          internalCheckout: internalCheckoutURL === "true" ? true : false,
          planLanguages: [
            {
              lingoLanguageId: 1,
              focus: "business",
              struct: "conversational",
              studentLanguageLevel: "basic",
            },
          ],
        };

        await dispatch(subscriptionsStripe(body))
          .then((resp) => {
            if (resp) {
              setCustomerId(resp.customerId);
              setSubscriptionId(resp.providerTransactionId);
              setClientSecret(resp.providerTransactionToken);

              setShowPayment(true);
            }
          })
          .catch((error) => {
            const message = error?.response?.data?.error;

            if (message.includes("already exists!")) {
              sessionStorage.setItem("@rememberEmail", email);
              setModalAlert({
                show: true,
                titleButton: "BTN_LOGIN",
                title: "INVALID_FORM_TITLE",
                description: `${t("INVALID_FORM_CHECKOUT7")} ${email} ${t("INVALID_FORM_CHECKOUT7_1")}`,
              });
            } else {
              setModalAlert({
                show: true,
                description: message,
                titleButton: "BTN_CLOSE",
                title: "INVALID_FORM_TITLE",
              });
            }
          });
      }

      const responsePlans = await dispatch(
        subscriptionsStripeGetPlans(
          planIdURL,
          priceIdURL,
          currencyURL === "BRL" ? "BR" : "US",
          "",
          false,
          partnerURL,
          cpnURL,
        ),
      );

      if (responsePlans) {
        setPlans(responsePlans);
      } else {
        setModalAlert({
          show: true,
          titleButton: "BACK",
          title: "INVALID_FORM_TITLE",
          description: "INVALID_FORM_CHECKOUT8",
        });
      }
    } else {
      setCurrencyURL(currencyURL);
      setUserInfo(responseIPAPI);
      setAffiliateId(affiliateURL);

      if (partnerURL !== "null" && partnerURL !== undefined) {
        dispatch(getInfoPartners(partnerURL)).then((res) => setPartnersInfo(res));
      }

      const countryURL = responseIPAPI?.country_code === "BR" || currencyURL === "BRL" ? "BR" : "US";
      let contry = isAuthenticated
        ? studentPlan?.currency
          ? studentPlan?.currency !== "USD"
            ? "BR"
            : "US"
          : responseIPAPI?.country_code === "BR"
          ? "BR"
          : "US"
        : countryURL;

      const responsePlans = await dispatch(
        subscriptionsStripeGetPlans(planIdURL, priceIdURL, contry, "", false, partnerURL, cpnURL),
      );

      if (responsePlans) {
        setPlans(responsePlans);
      } else {
        setModalAlert({
          show: true,
          titleButton: "BACK",
          title: "INVALID_FORM_TITLE",
          description: "INVALID_FORM_CHECKOUT8",
        });
      }
    }
  };

  const validateForms = () => {
    if (name.trim() === "") {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT1",
      });

      return false;
    } else if (email.trim() === "") {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT2",
      });

      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT3",
      });

      return false;
    } else if (phone === "") {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT4",
      });

      return false;
    } else if (country === "") {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT5",
      });

      return false;
    } else if (invalidPass.find((item) => item.status === null)) {
      const message = invalidPass.find((item) => item.status === null).message;
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: message,
      });

      return false;
    } else if (recaptchaValue === null && !isAuthenticated) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT13",
      });

      return false;
    } else return true;
  };

  const handleSubmitCreateAccount = async (e) => {
    e.preventDefault();

    if (validateForms()) {
      const body = {
        student: {
          name: name.trim(),
          countryId: Number(country),
          timezone: userInfo?.timezone,
          userPhones: [{ phone, userPhoneTypeId: 3 }],
          email: encryptValue(email.toLowerCase().trim()),
          userPassword: { password: encryptValue(password) },
          currency: userInfo?.currency === "BRL" || currencyURL === "BRL" ? "BRL" : "USD",
        },
        planId: plans?.planId,
        priceId: plans?.priceId,
        affiliateId: affiliateId,
        planLanguages: [
          {
            lingoLanguageId: 1,
            focus: "business",
            struct: "conversational",
            studentLanguageLevel: "basic",
          },
        ],
      };

      await dispatch(subscriptionsStripe(body))
        .then((resp) => {
          if (resp) {
            setCustomerId(resp.customerId);
            setSubscriptionId(resp.providerTransactionId);
            setClientSecret(resp.providerTransactionToken);

            setShowPayment(true);
            setShowCreateAccount(false);
          }
        })
        .catch((error) => {
          const message = error?.response?.data?.error;

          if (message.includes("already exists!")) {
            sessionStorage.setItem("@rememberEmail", email);
            setModalAlert({
              show: true,
              titleButton: "BTN_LOGIN",
              title: "INVALID_FORM_TITLE",
              description: `${t("INVALID_FORM_CHECKOUT7")} ${email} ${t("INVALID_FORM_CHECKOUT7_1")}`,
            });
          } else {
            setModalAlert({
              show: true,
              description: message,
              titleButton: "BTN_CLOSE",
              title: "INVALID_FORM_TITLE",
            });
          }
        });
    }
  };

  const handleBuy = async (e) => {
    e.preventDefault();

    if (privacyTerms === false) {
      setModalAlert({
        show: true,
        titleButton: "BTN_CLOSE",
        title: "INVALID_FORM_TITLE",
        description: "INVALID_FORM_CHECKOUT6",
      });
      return;
    }

    if (changeType !== "upgrade" && changeType !== "downgrade") {
      const buttonSubmitStripe = document.getElementById("btn-stripe-checkout");
      buttonSubmitStripe.click();
    } else {
      if (cardPay === "new") {
        const buttonSubmitStripe = document.getElementById("btn-stripe-checkout");
        buttonSubmitStripe.click();
      } else {
        await dispatch(
          postChangePlan(changeType, changeTypeSchedule, selectedPlanId, plans?.planId, plans?.priceId, cardPay),
        )
          .then(() =>
            setModalAlert({
              show: true,
              titleButton: "OK",
              title: "THANKS",
              description: "WELCOME_TO_LINGO_CHANGE",
            }),
          )
          .catch((error) => {
            const message = error?.response?.data?.error;
            setModalAlert({
              show: true,
              titleButton: "BTN_CLOSE",
              title: "INVALID_FORM_TITLE",
              description: message,
            });
          });
      }
    }
  };

  const renderStripeComponentNewCard = async (e, type) => {
    e?.preventDefault();
    setCardPay(type);

    await dispatch(postUpgradeDdowngrade(Number(selectedPlanId)))
      .then((res) => {
        setClientSecret(res.client_secret);
        setShowPayment(true);
      })
      .catch((error) => {
        const message = error?.response?.data?.error;
        setModalAlert({
          show: true,
          titleButton: "BTN_CLOSE",
          title: "INVALID_FORM_TITLE",
          description: message,
        });
      });
  };

  const renderInputPhone = () => {
    return (
      <IntlTelInput
        inputClassName="form-control"
        containerClassName="intl-tel-input"
        style={{ marginBottom: 15, zIndex: 100, width: "105%" }}
        defaultCountry={userInfo?.country_code?.toLowerCase() ?? "us"}
        onPhoneNumberChange={(_, value, countryData, number) => {
          console.log(value, countryData); //nao remover

          const numberFormatted = number.replace(/\D/g, "");
          setPhone(`+${numberFormatted}`);
        }}
      />
    );
  };

  const checkPassword = useCallback(
    async (e, type) => {
      if (type === "password") setPassword(e.target.value);
      else if (type === "confirmation") setPasswordConfirmation(e.target.value);

      setInvalidPassword(passwordValidator(password, passwordConfirmation));
    },
    [password, passwordConfirmation],
  );

  const handleBack = () => {
    if (isAuthenticated) {
      navigate(-1);
    } else {
      window.location.href = "https://www.lingofor.me/lingo-us/lingo_plans.html";
    }
  };

  const onChangeRecaptcha = async (value) => {
    setRecaptchaValue(value);
    // await dispatch(recaptchaValidate(value));
  };

  const currency = userInfo?.country_code === "BR" || currencyURL === "BRL" ? "R$ " : "USD";
  const parts = plans?.final_value?.toString()?.split(".") ?? "--";
  const cents = parts?.length > 1 ? parts[1] : "00";

  useEffect(() => {
    if (password) checkPassword();
  }, [password, passwordConfirmation, checkPassword]);

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <NavBar title="Checkout" description="Checkout" />

      <WrapperButtonBack>
        <Buttonback back="true" onClick={handleBack}>
          {t("BACK")}
        </Buttonback>
      </WrapperButtonBack>

      <Content>
        {!isAuthenticated ? (
          <FormContainer>
            <WrapperTitle hidden={showCreateAccount.toString()}>
              <Circle>
                <span>1</span>
              </Circle>
              <Title>{t("CREATE_YOUR_ACCOUNT")}</Title>
              {!showCreateAccount && <FaRegCircleCheck size={22} color="#3cacfc" />}
            </WrapperTitle>

            <div>
              <Line />

              {showCreateAccount ? (
                <FormContent>
                  <Inputs
                    type="text"
                    value={name}
                    autoComplete="off"
                    label={t("NAME_FULL")}
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setName(target.value)}
                  />
                  <Inputs
                    type="email"
                    value={email}
                    autoComplete="off"
                    label={t("EMAIL")}
                    style={{ marginBottom: 37 }}
                    onChange={({ target }) => setEmail(target.value)}
                  />

                  {renderInputPhone()}

                  <input className="inputAutoCompleteEmail" />

                  <Select
                    width="105"
                    label={t("COUNTRY")}
                    options={COUNTRIES}
                    style={{ marginBottom: 50 }}
                    onChange={({ target }) => setCountry(target.value)}
                  />
                  <Inputs
                    password
                    value={password}
                    autoComplete="off"
                    label={t("PASSWORD")}
                    showPassword={showPassword}
                    style={{ marginBottom: 37 }}
                    onBlur={() => checkPassword()}
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => checkPassword(e, "password")}
                    onClickPassword={() => setShowPassword(!showPassword)}
                  />
                  <Inputs
                    password
                    autoComplete="off"
                    style={{ marginBottom: 37 }}
                    value={passwordConfirmation}
                    label={t("PASSWORD_CONFIRM")}
                    onBlur={() => checkPassword()}
                    showPassword={showPasswordConfirmation}
                    onChange={(e) => checkPassword(e, "confirmation")}
                    type={showPasswordConfirmation ? "text" : "password"}
                    onClickPassword={() => setShowPasswordConfirmation(!showPasswordConfirmation)}
                  />

                  <WrapperInvalidPassword>
                    {invalidPass &&
                      invalidPass.map((message, index) =>
                        message.status === null || message.status === false ? (
                          <div key={index}>
                            <MdError size={16} color="#979797" />
                            <p>
                              {t(message.message)} {message.id === 4 && "Ex: @#!$%^&*()-"}
                            </p>
                          </div>
                        ) : (
                          <div key={index}>
                            <MdCheckCircle size={16} color="#3cacfc" />
                            <p style={{ color: "#3cacfc" }}>
                              {t(message.message)} {message.id === 4 && "Ex: @#!$%^&*()-"}
                            </p>
                          </div>
                        ),
                      )}
                  </WrapperInvalidPassword>

                  <ReCAPTCHA sitekey={keyRecaptcha} onChange={(value) => onChangeRecaptcha(value)} />

                  <ButtonNext onClick={handleSubmitCreateAccount}>{t("BTN_NEXT")}</ButtonNext>
                </FormContent>
              ) : (
                <FormContent />
              )}
            </div>

            <WrapperTitle hidden={showPayment.toString()}>
              <Circle>
                <span>2</span>
              </Circle>
              <Title>{t("PAYMENT")}</Title>
            </WrapperTitle>

            <div>
              {showPayment ? (
                <>
                  <Line />

                  <FormContent>
                    <CheckoutStripeComponent
                      type="checkout"
                      changeType={""}
                      studentPlans={""}
                      changeTypeAt={""}
                      planId={plans?.planId}
                      priceId={plans?.priceId}
                      customerId={customerId}
                      clientSecret={clientSecret}
                      setModalAlert={setModalAlert}
                      subscriptionId={subscriptionId}
                      loginUser={{ email: email.toLowerCase().trim(), password: password }}
                      currency={userInfo?.currency === "BRL" || currencyURL === "BRL" ? "BRL" : "USD"}
                    />

                    <CardReviewSubscription>
                      <DivLeft>
                        <div>
                          <sub>{currency}</sub>
                          <span>{parts[0]}</span>
                          <sub>,{cents} </sub>
                          <sub>/{t("MONTH")}</sub>
                        </div>

                        {plans?.discount_percent !== 0 && (
                          <Discount>
                            {t("ABBREVIATED_DISCOUNT")} {plans?.discount_percent}%
                          </Discount>
                        )}
                      </DivLeft>

                      <DivRight>
                        <p>
                          {t("REVIEW_SUBSCRIPTION_TEXT1")} <span>{t("REVIEW_SUBSCRIPTION_TEXT2")}</span>{" "}
                          {t("REVIEW_SUBSCRIPTION_TEXT3")} {currency} {parts[0]},{cents},{" "}
                          {t("REVIEW_SUBSCRIPTION_TEXT4")}
                        </p>

                        <div style={{ cursor: "pointer" }}>
                          <input
                            type="checkbox"
                            id="privacyTerms"
                            name="privacyTerms"
                            checked={privacyTerms}
                            onChange={() => setPrivacyTerms((state) => !state)}
                            style={{ cursor: "pointer" }}
                          />
                          <label htmlFor={"privacyTerms"} style={{ cursor: "pointer" }}>
                            {t("PRIVACY_TERMS_TEXT")}
                          </label>
                        </div>
                      </DivRight>
                    </CardReviewSubscription>

                    <TextPrivacyTerms>
                      <p>{t("ALL_OUR_PLANS")}</p>
                      <p>
                        {t("SIGN_FOR_LINGO")}
                        <a
                          rel="noreferrer"
                          href="https://www.lingofor.me/lingo-us/lingo_privacidade.html"
                          target="_blank"
                        >
                          {t("PRIVACY_POLICY")}
                        </a>
                        .
                      </p>
                    </TextPrivacyTerms>

                    <WrapperBuy>
                      <img src={poweredStipePNG} />
                      <ButtonNext id="botaoDestino" onClick={handleBuy}>
                        {t("BTN_BUY")}
                      </ButtonNext>
                    </WrapperBuy>
                  </FormContent>
                </>
              ) : (
                <FormContent />
              )}
            </div>
          </FormContainer>
        ) : (
          <FormContainerAuth>
            <WrapperTitle hidden={showCreateAccount.toString()}>
              <Circle>
                <span>1</span>
              </Circle>
              <Title>{t("PERSONAL_INFORMATION")}</Title>
              <FaRegCircleCheck size={22} color="#3cacfc" />
            </WrapperTitle>

            <div>
              <Line />

              <FormContent />
            </div>

            {changeType === "checkout" ? (
              <>
                <WrapperTitle hidden={showPayment.toString()}>
                  <Circle>
                    <span>2</span>
                  </Circle>
                  <Title>{t("PAYMENT")}</Title>
                </WrapperTitle>

                <div>
                  <Line />
                  <FormContent>
                    {showPayment && clientSecret && (
                      <CheckoutStripeComponent
                        cardPay={cardPay}
                        planId={plans?.planId}
                        customerId={customerId}
                        priceId={plans?.priceId}
                        clientSecret={clientSecret}
                        setModalAlert={setModalAlert}
                        subscriptionId={subscriptionId}
                        changeTypeAt={changeTypeSchedule}
                        changeType={changeType !== "" ? changeType : ""}
                        studentPlans={selectedPlanId !== 0 ? selectedPlanId : ""}
                        currency={currencyURL !== "" ? currencyURL : studentPlan?.currency}
                        loginUser={{ email: email.toLowerCase().trim(), password: password }}
                        type={changeType === "upgrade" || changeType === "downgrade" ? "upgradeDdowngrade" : "checkout"}
                      />
                    )}
                    <CardReviewSubscription>
                      <DivLeft>
                        <div>
                          <sub>{currency}</sub>
                          <span>{parts[0]}</span>
                          <sub>,{cents} </sub>
                          <sub>/{t("MONTH")}</sub>
                        </div>

                        {plans?.discount_percent !== 0 && (
                          <Discount>
                            {t("ABBREVIATED_DISCOUNT")} {plans?.discount_percent}%
                          </Discount>
                        )}
                      </DivLeft>

                      <DivRight>
                        <p>
                          {t("REVIEW_SUBSCRIPTION_TEXT1")} <span>{t("REVIEW_SUBSCRIPTION_TEXT2")}</span>{" "}
                          {t("REVIEW_SUBSCRIPTION_TEXT3")} {currency} {parts[0]},{cents},{" "}
                          {t("REVIEW_SUBSCRIPTION_TEXT4")}
                        </p>

                        <div style={{ cursor: "pointer" }}>
                          <input
                            type="checkbox"
                            id="privacyTerms"
                            name="privacyTerms"
                            checked={privacyTerms}
                            onChange={() => setPrivacyTerms((state) => !state)}
                            style={{ cursor: "pointer" }}
                          />
                          <label htmlFor={"privacyTerms"} style={{ cursor: "pointer" }}>
                            {t("PRIVACY_TERMS_TEXT")}
                          </label>
                        </div>
                      </DivRight>
                    </CardReviewSubscription>

                    <TextPrivacyTerms>
                      <p>{t("ALL_OUR_PLANS")}</p>
                      <p>
                        {t("SIGN_FOR_LINGO")}
                        <a
                          rel="noreferrer"
                          href="https://www.lingofor.me/lingo-us/lingo_privacidade.html"
                          target="_blank"
                        >
                          {t("PRIVACY_POLICY")}
                        </a>
                        .
                      </p>
                    </TextPrivacyTerms>

                    <WrapperBuy>
                      <img src={poweredStipePNG} />
                      <ButtonNext id="botaoDestino" onClick={handleBuy}>
                        {t("BTN_BUY")}
                      </ButtonNext>
                    </WrapperBuy>
                  </FormContent>
                </div>
              </>
            ) : (
              <>
                <WrapperTitle hidden={showCreateAccount.toString()}>
                  <Circle>
                    <span>2</span>
                  </Circle>
                  <Title>{t("ACTIVATION")}</Title>
                  {changeTypeSchedule !== "" && <FaRegCircleCheck size={22} color="#3cacfc" />}
                  {changeTypeSchedule !== "" && changeType !== "downgrade" && (
                    <Buttonback
                      back="true"
                      onClick={() => {
                        setCardPay("");
                        setShowPayment(false);
                        setChangeTypeSchedule("");
                      }}
                      style={{ marginBottom: 0, marginLeft: 15 }}
                    >
                      {t("CHANGE")}
                    </Buttonback>
                  )}
                </WrapperTitle>
                <div>
                  <Line />

                  {changeTypeSchedule === "" ? (
                    <FormContent>
                      {changeType === "upgrade" && (
                        <BtImageCheckout
                          onClick={(e) => {
                            e.preventDefault();
                            setChangeTypeSchedule(changeTypeSchedule === "now" ? "" : "now");
                            setCardPay("");
                            setShowPayment(true);
                            dispatch(setTypeSchedule("now"));
                          }}
                          active={changeTypeSchedule === "now"}
                        >
                          <img src={ActivationImmdiateIMG} alt="imgChckout" />
                          <div className="column">
                            <p>
                              {t("ACTIVATION")} <strong>{t("IMMEDIATE")}</strong>
                            </p>
                            <span>{t("CHANGE_NOW")}</span>
                          </div>
                        </BtImageCheckout>
                      )}
                      <BtImageCheckout
                        onClick={(e) => {
                          e.preventDefault();
                          setCardPay("");
                          setShowPayment(true);
                          dispatch(setTypeSchedule("nextCycle"));
                          setChangeTypeSchedule(changeTypeSchedule === "nextCycle" ? "" : "nextCycle");
                        }}
                        active={changeTypeSchedule === "nextCycle"}
                      >
                        <img src={ActivationScheduledIMG} alt="imgChckout" />
                        <div className="column">
                          <p>
                            {t("ACTIVATION")} <strong>{t("SCHEDULED")}</strong>
                          </p>
                          <span>{t("NEXT_CYCLE")}</span>
                        </div>
                      </BtImageCheckout>
                    </FormContent>
                  ) : (
                    <FormContent />
                  )}
                </div>

                <WrapperTitle hidden={showPayment.toString()}>
                  <Circle>
                    <span>3</span>
                  </Circle>
                  <Title>{t("PAYMENT")}</Title>
                </WrapperTitle>

                <div>
                  {showPayment ? (
                    <>
                      <Line />
                      <FormContent>
                        {studentPlan?.cardInfo && (
                          <BtImageCheckout
                            onClick={(e) => {
                              renderStripeComponentNewCard(e, cardPay === "current" ? "" : "current");
                            }}
                            active={cardPay === "current"}
                          >
                            <img src={SameCardIMG} alt="imgChckout" />
                            <div className="column">
                              <p>
                                {t("SAME")} <strong>{t("CARD")}</strong>
                              </p>
                              <LineCard cardInfo={studentPlan?.cardInfo} />
                            </div>
                          </BtImageCheckout>
                        )}
                        <BtImageCheckout
                          onClick={(e) => {
                            renderStripeComponentNewCard(e, cardPay === "new" ? "" : "new");
                          }}
                          active={cardPay === "new"}
                          style={
                            showPayment && clientSecret && cardPay === "new"
                              ? { marginBottom: 50 }
                              : { marginBottom: 20 }
                          }
                        >
                          <img src={NewCardIMG} alt="imgChckout" />
                          <div className="column">
                            <p>
                              {t("NEW")} <strong>{t("CARD")}</strong>
                            </p>
                            <span>{t("NEW_CARD")}</span>
                          </div>
                        </BtImageCheckout>

                        {showPayment && clientSecret && (
                          <CheckoutStripeComponent
                            cardPay={cardPay}
                            planId={plans?.planId}
                            customerId={customerId}
                            priceId={plans?.priceId}
                            clientSecret={clientSecret}
                            setModalAlert={setModalAlert}
                            subscriptionId={subscriptionId}
                            currency={studentPlan?.currency}
                            changeTypeAt={changeTypeSchedule}
                            changeType={changeType !== "" ? changeType : ""}
                            studentPlans={selectedPlanId !== 0 ? selectedPlanId : ""}
                            loginUser={{ email: email.toLowerCase().trim(), password: password }}
                            type={
                              changeType === "upgrade" || changeType === "downgrade" ? "upgradeDdowngrade" : "checkout"
                            }
                          />
                        )}
                        <CardReviewSubscription>
                          <DivLeft>
                            <div>
                              <sub>{currency}</sub>
                              <span>{parts[0]}</span>
                              <sub>,{cents} </sub>
                              <sub>/{t("MONTH")}</sub>
                            </div>

                            {plans?.discount_percent !== 0 && (
                              <Discount>
                                {t("ABBREVIATED_DISCOUNT")} {plans?.discount_percent}%
                              </Discount>
                            )}
                          </DivLeft>

                          <DivRight>
                            <p>
                              {t("REVIEW_SUBSCRIPTION_TEXT1")} <span>{t("REVIEW_SUBSCRIPTION_TEXT2")}</span>{" "}
                              {t("REVIEW_SUBSCRIPTION_TEXT3")} {currency} {parts[0]},{cents},{" "}
                              {t("REVIEW_SUBSCRIPTION_TEXT4")}
                            </p>

                            <div style={{ cursor: "pointer" }}>
                              <input
                                type="checkbox"
                                id="privacyTerms"
                                name="privacyTerms"
                                checked={privacyTerms}
                                onChange={() => setPrivacyTerms((state) => !state)}
                                style={{ cursor: "pointer" }}
                              />
                              <label htmlFor={"privacyTerms"} style={{ cursor: "pointer" }}>
                                {t("PRIVACY_TERMS_TEXT")}
                              </label>
                            </div>
                          </DivRight>
                        </CardReviewSubscription>

                        <TextPrivacyTerms>
                          <p>{t("ALL_OUR_PLANS")}</p>
                          <p>
                            {t("SIGN_FOR_LINGO")}
                            <a
                              rel="noreferrer"
                              href="https://www.lingofor.me/lingo-us/lingo_privacidade.html"
                              target="_blank"
                            >
                              {t("PRIVACY_POLICY")}
                            </a>
                            .
                          </p>
                        </TextPrivacyTerms>

                        <WrapperBuy>
                          <img src={poweredStipePNG} />
                          <ButtonNext id="botaoDestino" onClick={handleBuy}>
                            {t("BTN_BUY")}
                          </ButtonNext>
                        </WrapperBuy>
                      </FormContent>
                    </>
                  ) : (
                    <FormContent />
                  )}
                </div>
              </>
            )}
          </FormContainerAuth>
        )}

        <CardInfo data={plans} userInfo={userInfo} partnersInfo={partnersInfo} currencyURL={currencyURL} />
      </Content>

      <ModalAlert modalAlert={modalAlert} setModalAlert={setModalAlert} currencyURL={currencyURL} />
    </Container>
  );
}

export default CheckoutSite;
